import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../core/services/auth';

export const AlreadyAuthenticatedGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (await authService.isLoggedIn()) {
    return router.createUrlTree(['/']);
  }

  return true;
};
